/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<7d6355b3237afef20dc2b8ac1fcbafa4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type elementErrorBoundaryFragment$data = {
  readonly __typename: "QueryError";
  readonly identifier: string | null | undefined;
  readonly " $fragmentType": "elementErrorBoundaryFragment";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "elementErrorBoundaryFragment";
};
export type elementErrorBoundaryFragment$key = {
  readonly " $data"?: elementErrorBoundaryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"elementErrorBoundaryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "elementErrorBoundaryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "identifier",
          "storageKey": null
        }
      ],
      "type": "QueryError",
      "abstractKey": null
    }
  ],
  "type": "HelpLayoutElement",
  "abstractKey": "__isHelpLayoutElement"
};

(node as any).hash = "ad768fe07d8d8c3351452c65d54888d0";

export default node;
